import { useQuery } from '@tanstack/react-query';
import { isEmpty } from 'underscore';
import useDatasetStore from "../store/datasetStore";
import Api from "../api/Api";
import useAuthStore from "../store/authStore";
import { QUERY_KEYS } from "./queryKeys";
import { useEffect } from "react";

export const useRegularDatasetBriefs = (enabled = false) => {
  return useQuery({
    queryKey: [QUERY_KEYS.dataset.datasetBriefs],
    queryFn: () => Api.search.dataSetBriefs({
      includeGlobal: false,
    }),
    enabled: enabled,
    retry: 3,
  });
};

export const useFWEDatasetBriefs = () => {
  const user = useAuthStore(state => state.user);

  return useQuery({
    queryKey: [QUERY_KEYS.dataset.datasetBriefsFwe],
    queryFn: () => Api.search.dataSetBriefs({
      includeGlobal: false,
      vas: 'fwe'
    }),
    enabled: !isEmpty(user) && user.authenticated
  });
};

export const useInitDatasetBriefs = () => {
  const isAuthenticated  = useAuthStore(state => state.isAuthenticated);
  const setDatasetBrief = useDatasetStore(state => state.setDatasetBrief);
  const setFWEDatasetBrief = useDatasetStore(state => state.setFWEDatasetBrief);
  const isApiInitialized = Boolean(Api?.configData);

  const regularDataQuery = useRegularDatasetBriefs(isApiInitialized);
  const fweDataQuery = useFWEDatasetBriefs();

  useEffect(() => {
    const authenticated = isAuthenticated();

    if (regularDataQuery.data) {
      if (!authenticated) {
        setDatasetBrief(regularDataQuery.data);
        setFWEDatasetBrief([]);
      } else if (authenticated && fweDataQuery.data) {
        setDatasetBrief(regularDataQuery.data.concat(fweDataQuery.data));
        setFWEDatasetBrief(fweDataQuery.data);
      } else if (authenticated && !fweDataQuery.data && !fweDataQuery.isLoading) {
        setDatasetBrief(regularDataQuery.data);
        setFWEDatasetBrief([]);
      }
    }
  }, [
    regularDataQuery.data,
    fweDataQuery.data,
    fweDataQuery.isLoading,
    isAuthenticated,
    setDatasetBrief,
    setFWEDatasetBrief
  ]);
};
